import { defineComponent as _defineComponent } from 'vue'
import { BookV1, NewBookV1, Properties } from '@ilteducation/content-registry-types';

import BooksForm from './Form.vue';

type Props = {
  id?: string;
  title: string;
  item?: BookV1;
};

// TODO: remove when type generation work in content-registry.
type AdminProperties = Properties & {
  frog?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item?: BookV1;
}

const Book: NewBookV1 & { properties: AdminProperties } = {
  type: 'BookV1',
  realm: undefined,
  availabilityRealms: [],
  isbn: '',
  title: '',
  authors: [],
  publisher: {
    id: '',
    name: '',
  },
  languages: {
    mainLanguage: '',
    text: undefined,
  },
  accessRules: {
    services: [],
    subscriptionType: [],
  },
  properties: {
    sentenceHighlighting: false,
    reflowable: false,
    pageProgressionDirection: 'ltr',
    pictureInPicture: [],
    additionalContent: {
      kahoot: false,
      teachingMaterial: false,
      externalMaterial: false,
    },
    frog: false,
    isSpeakingBook: false,
  },
};

let cloned: NewBookV1 | undefined;
if (props?.item) {
  const { id, bookId, createdAt, lastUpdatedAt, versions, activeVersion, file, ...rest } = props.item;
  cloned = rest;
}
const defaultBook = cloned ?? Book;
const isClone = !!cloned;

return { __sfc: true,Book, props, cloned, defaultBook, isClone, BooksForm }
}

})